// Product of Launch Maniac LLC, Las Vegas, Nevada - (725) 444-8200 support@launchmaniac.com

// Frontend subset of enums from backend types/enums.ts
// Only includes enums referenced by view components

export enum CampaignStatus {
  DRAFT = 'DRAFT',
  READY = 'READY',
  ARMED = 'ARMED',
  SENDING = 'SENDING',
  RUNNING = 'RUNNING',
  PAUSED = 'PAUSED',
  CLOSED = 'CLOSED',
  ARCHIVED = 'ARCHIVED',
}

export enum SegmentKey {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  HOLDOUT = 'HOLDOUT',
}

export enum ClassificationCategory {
  INTERESTED = 'INTERESTED',
  QUESTION = 'QUESTION',
  APPOINTMENT_INTENT = 'APPOINTMENT_INTENT',
  QUOTE_REQUEST = 'QUOTE_REQUEST',
  NOT_INTERESTED = 'NOT_INTERESTED',
  WRONG_NUMBER = 'WRONG_NUMBER',
  STOP = 'STOP',
  UNCLASSIFIED = 'UNCLASSIFIED',
}

export enum LedgerEventType {
  ENGAGED_VERIFIED = 'ENGAGED_VERIFIED',
  APPT_VERIFIED = 'APPT_VERIFIED',
  REVENUE_VERIFIED = 'REVENUE_VERIFIED',
  CALL_ENGAGED = 'CALL_ENGAGED',
  CREDIT_APPLIED = 'CREDIT_APPLIED',
}

export enum WeeklyCloseState {
  OPEN = 'OPEN',
  GENERATING = 'GENERATING',
  READY = 'READY',
  CLOSED = 'CLOSED',
  REOPENED = 'REOPENED',
}

export enum ExportFormat {
  CSV = 'CSV',
  XLSX = 'XLSX',
}

export enum ExportType {
  ACTIVITY = 'ACTIVITY',
  REVENUE = 'REVENUE',
}

export enum DisputeState {
  FILED = 'FILED',
  VALIDATED = 'VALIDATED',
  REJECTED = 'REJECTED',
  UNDER_REVIEW = 'UNDER_REVIEW',
  RESOLVED_UPHELD = 'RESOLVED_UPHELD',
  RESOLVED_ADJUSTED = 'RESOLVED_ADJUSTED',
  CREDIT_ISSUED = 'CREDIT_ISSUED',
}

export enum SuppressionReason {
  STOP = 'STOP',
  DNC = 'DNC',
  WRONG_NUMBER = 'WRONG_NUMBER',
  OTHER = 'OTHER',
}

export enum UserRole {
  ADMIN = 'ADMIN',
  OPERATOR = 'OPERATOR',
  SDR = 'SDR',
  READ_ONLY = 'READ_ONLY',
}

export enum TwilioRegistrationStatus {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  LIVE = 'LIVE',
  REJECTED = 'REJECTED',
}

export enum ImportStatus {
  UPLOADING = 'UPLOADING',
  MAPPING = 'MAPPING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}
